import * as apiUtils from "@/utils/apiUtils"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {},
  // -----------------------------------------------------------------
  getters: {},
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    // Vendors
    getVendor: (context, tid) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/vendors/" + tid
      return apiUtils.get(path)
    },
    getVendors: (context, query) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/vendors"
      return apiUtils.get(path, query)
    },
    createVendor: (
      context,
      {
        name,
        email,
        currencyCode,
        countryCode,
        postalCode,
        address,
        address2,
        accountNumber,
        phone,
        fax,
        mobile,
        website,
        bankSwiftCode,
        bankName,
        bankAddress
      }
    ) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/vendors"
      return apiUtils.post(path, {
        name,
        email,
        currencyCode,
        countryCode,
        postalCode,
        address,
        address2,
        accountNumber,
        phone,
        fax,
        mobile,
        website,
        bankSwiftCode,
        bankName,
        bankAddress
      })
    },
    updateVendor: (
      context,
      {
        id,
        name,
        email,
        currencyCode,
        countryCode,
        postalCode,
        address,
        address2,
        accountNumber,
        phone,
        fax,
        mobile,
        website,
        bankSwiftCode,
        bankName,
        bankAddress
      }
    ) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/vendors/" + id
      return apiUtils.patch(path, {
        name,
        email,
        currencyCode,
        countryCode,
        postalCode,
        address,
        address2,
        accountNumber,
        phone,
        fax,
        mobile,
        website,
        bankSwiftCode,
        bankName,
        bankAddress
      })
    },
    deleteVendor: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/vendors/" + id
      return apiUtils.delete(path)
    }
  }
}
